import { FC } from "react";
import { RouterParamType } from "@/model/navModel";
import { useVrmMaintenanceDetailsModel } from "../vrmBillMaintenanceRoModel";

enum OperatorUserType {
    "内部员工" = 1,
    "团队" = 2,
    "客户" = 3,
}
export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    const { detailLookForm } = useVrmMaintenanceDetailsModel()

    return (
        <div className="list-container" style={{ position: 'fixed', left: '250px', bottom: 0, width: 'calc(100% - 280px)', zIndex: 999 }}>
            <div className="form-details-warp bottom-info" style={{ padding: '10px 20px' }}>
                <span style={{ paddingLeft: '10px' }}>开单时间：{detailLookForm.createTime || '暂无'}</span>
                <span style={{ paddingLeft: '30px' }}>开单员：{detailLookForm.billName || '暂无'}</span>
                <span style={{ paddingLeft: '30px' }}>创建人：{`${OperatorUserType[detailLookForm.createUserType ?? 1]}--${detailLookForm.createUserName}` || '暂无'}</span>
                <span style={{ paddingLeft: '30px' }}>审核人：{detailLookForm.reviewerName || '暂无'}</span>
                <span style={{ paddingLeft: '30px' }}>审核时间：{detailLookForm.reviewerTime || '暂无'}</span>
                <span style={{ paddingLeft: '30px' }}>经营实体审核人：{detailLookForm.ciBusinessEntityReviewerName || '暂无'}</span>
                {detailLookForm.repairTime && (
                    <span style={{ paddingLeft: '30px' }}>维修时间：{detailLookForm.repairTime || '暂无'}</span>
                )}
                {detailLookForm.orderStatus === 'cancelled' && (
                    <>
                        <span style={{ paddingLeft: '30px' }}>取消人：{detailLookForm.orderCancelUserName || '暂无'}</span>
                        <span style={{ paddingLeft: '30px' }}>取消时间：{detailLookForm.orderCancelTime || '暂无'}</span>
                    </>
                )}
            </div>
        </div>
    )
}